export const productsData = [
  {
    id: 1,
    name: 'iPhone 15 Pro Max',
    category: 'Electronics',
    price: 1299,
    stock: 45,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 2,
    name: 'MacBook Pro M3',
    category: 'Electronics',
    price: 2499,
    stock: 23,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 3,
    name: 'Nike Air Max',
    category: 'Footwear',
    price: 159,
    stock: 0,
    status: 'Inactive',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 4,
    name: 'Samsung Galaxy S24',
    category: 'Electronics',
    price: 899,
    stock: 67,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 5,
    name: 'Adidas Ultraboost',
    category: 'Footwear',
    price: 189,
    stock: 34,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 6,
    name: 'Sony WH-1000XM5',
    category: 'Audio',
    price: 349,
    stock: 12,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 7,
    name: 'iPad Pro 12.9"',
    category: 'Electronics',
    price: 1099,
    stock: 28,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 8,
    name: 'Canon EOS R5',
    category: 'Camera',
    price: 3899,
    stock: 8,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 9,
    name: 'Apple Watch Ultra',
    category: 'Wearables',
    price: 799,
    stock: 15,
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=100&h=100&fit=crop&crop=center'
  },
  {
    id: 10,
    name: 'Tesla Model Y Toy',
    category: 'Toys',
    price: 89,
    stock: 0,
    status: 'Inactive',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop&crop=center'
  }
];

export const categories = [
  'Electronics',
  'Footwear',
  'Audio',
  'Camera',
  'Wearables',
  'Toys',
  'Clothing',
  'Books',
  'Home & Garden'
];